// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"5d656cfe","839":"861f106c"}[chunkId] + ".chunk.js";
};